import { useBoundStore } from '@Store/useBoundStore';
import { trackEvent } from '@Services/analytics/tracking.service';
import type { REASON_FOR_OPEN } from '../consts';

export const useAccountOpeningReasonAnalytics = () => {
  const customerId = useBoundStore((state) => state.customer.customerId);
  const reportActOnAccountOpenReason = (reason: REASON_FOR_OPEN) => {
    trackEvent('action on reason opening account OB', {
      select_creation_reason: reason,
      distinct_id: customerId,
    });
  };

  return { reportActOnAccountOpenReason };
};
